module.exports = __webpack_public_path__ + "img/u3360.04e215e8.svg";